import React from 'react';
import { FileText, Download } from 'lucide-react';

const WhitepaperButton = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 w-full max-w-2xl mx-auto my-6">
      {/* View in Browser Button */}
      <a 
        href="/whitepaper.pdf" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex-1 bg-black border border-primary text-primary p-4 flex justify-center items-center gap-2 font-space-mono hover:bg-primary hover:text-black transition-colors uppercase tracking-widest group relative overflow-hidden"
      >
        <div className="absolute inset-0 bg-primary/10 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
        <FileText size={20} />
        Read Whitepaper
      </a>
      
      {/* Direct Download Button */}
      <a 
        href="/whitepaper.pdf" 
        download="NXT_Wave_Whitepaper.pdf"
        className="flex-1 bg-primary text-black border border-primary p-4 flex justify-center items-center gap-2 font-space-mono hover:bg-white hover:border-white transition-colors uppercase tracking-widest shadow-[0_0_15px_rgba(0,255,0,0.3)]"
      >
        <Download size={20} />
        Download PDF
      </a>
    </div>
  );
};

export default WhitepaperButton;
